import { Scheduler } from "./components";
import "./styles.css";
export type { SchedulerProps } from "./components/Scheduler/types";
export type { SchedulerData, SchedulerProjectData, ZoomLevel, Config } from "./types/global";

export { Scheduler };
